var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.031 24.548v-1.772l6.17-2.591v1.939l-4.073 1.52.064-.093v.226l-.064-.098 4.074 1.526v1.934l-6.17-2.59ZM16.787 28H14.52l2.944-8.727h2.808L23.217 28H20.95l-2.05-6.528h-.068L16.787 28Zm-.303-3.435h4.739v1.603h-4.739v-1.603ZM24.157 28v-8.727h3.605c.653 0 1.217.128 1.691.383.478.253.846.607 1.104 1.061.259.452.388.978.388 1.577 0 .602-.132 1.13-.396 1.581a2.657 2.657 0 0 1-1.121 1.044c-.486.247-1.063.37-1.73.37h-2.225v-1.661h1.833c.318 0 .584-.056.797-.166.215-.111.379-.266.49-.465.11-.201.166-.436.166-.703 0-.27-.056-.503-.166-.699a1.116 1.116 0 0 0-.49-.46c-.216-.108-.482-.162-.797-.162h-1.04V28h-2.11Zm9.937-8.727V28h-2.11v-8.727h2.11Zm7.865 5.275-6.17 2.591v-1.934l4.074-1.526-.06.098v-.226l.06.094-4.074-1.521v-1.94l6.17 2.592v1.772Z",
    fill: "#A3A3A9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A9",
    strokeWidth: 2,
    d: "M1 1h46v46H1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.85ec65f71eb004d1c1a785152d0bf76a.svg";
export { ForwardRef as ReactComponent };